import { Uploader } from '../../../../wrapped-cube-client';
import { selectors as nodeSelectors } from '../../../ducks/resource-nodes';
import { handleAssetDelete, handleFolderDelete } from './handleDelete';

export const handleDisposeResource = ({ getState, dispatch, action }) => {
  const { resourceType, resourceId } = action.meta?.apiClient || {};
  if (resourceType === 'file-upload') {
    const state = getState();
    const upload = nodeSelectors.getResourceById(
      state,
      resourceType,
      resourceId
    );
    if (upload) {
      Uploader.cancelUpload(upload, false);
    }
  }
  if (resourceType === 'folder') {
    handleFolderDelete({ resourceId, getState, dispatch });
  }

  if (resourceType === 'asset') {
    handleAssetDelete({ resourceId, resourceType, getState });
  }
};
